module.exports = __webpack_public_path__ + "static/media/snake.58e31033.jpeg";